angular.module('security', ['security.service', 'security.authorization']);
